import { render } from "./RecognitionsView.vue?vue&type=template&id=324d0a96"
import script from "./RecognitionsView.vue?vue&type=script&lang=js"
export * from "./RecognitionsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__